import { jsxs as e, jsx as t } from "react/jsx-runtime";
const a = (r) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ e(
        "g",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          clipPath: "url(#palette_svg__a)",
          children: [
            /* @__PURE__ */ t("path", { d: "M12 21a9 9 0 0 1 0-18c2.387 0 4.676.843 6.364 2.343S21 8.878 21 11c0 1.06-.474 2.078-1.318 2.828S17.694 15 16.5 15H14a2 2 0 0 0-1 3.75A1.3 1.3 0 0 1 12 21" }),
            /* @__PURE__ */ t(
              "path",
              {
                fill: "currentcolor",
                d: "M7.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M12 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "palette_svg__a", children: /* @__PURE__ */ t("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  a as default
};
